import { Header } from '@monorepo/shared/componentsV2/Header';
import { Search } from '@monorepo/shared/componentsV2/Search';
import { useCurrentProject } from '@monorepo/shared/hooks/useCurrentProject';
import React, { useCallback } from 'react';
import styled from 'styled-components';

const SearchContainer = styled.div`
  max-width: 10rem;
`;

interface LogsPageHeaderProps {
  onSearch?: (search: string) => void;
  filter: string;
  className?: string;
}

export function LogsPageHeader({
  className,
  onSearch,
  filter,
}: LogsPageHeaderProps) {
  const { project } = useCurrentProject();

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onSearch?.(e.target.value),
    [onSearch],
  );

  return (
    <Header
      className={className}
      rightActions={
        onSearch && (
          <SearchContainer>
            <Search onChange={handleSearch} value={filter} />
          </SearchContainer>
        )
      }
      title="Logs"
      subtitle={project?.name}
      variant="noDropShadow"
    />
  );
}
